import { messageCardUtil } from './MatchBody';

interface OrganisationMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  content: any;
}

const OrganisationMessageCard = ({ content }: OrganisationMessageCardProps) => {
  const options: any = {};
  options.pills = [];

  const organisationSize = content.organisationSize ? content.organisationSize.replace('to', '-') : '';
  const femalePercentage = content.femalePercentage ? `${content.femalePercentage}%` : '';
  const graduateIntake = content.graduatePositions;
  const foundYear = content.foundedYear;

  if (organisationSize !== '') {
    options.pills.push({
      icon: 'people-group',
      weight: 'far',
      width: 'w-3',
      text: `employees: ${organisationSize}`
    });
  }

  if (femalePercentage !== '') {
    options.pills.push({
      icon: 'venus',
      weight: 'far',
      text: `female employees: ${femalePercentage}`
    });
  }

  if (graduateIntake !== '') {
    options.pills.push({
      icon: 'user-graduate',
      weight: 'far',
      text: `graduate intake: ${graduateIntake}`
    });
  }

  if (foundYear !== '') {
    options.pills.push({
      icon: 'calendar',
      text: `founded: ${foundYear}`
    });
  }

  options.entityColor = 'deep-400';
  options.entityName = 'organisation';

  return messageCardUtil({ content, options });
};

export default OrganisationMessageCard;
